export class Denon900R {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.currentTrack = 1;
        this.totalTracks = 12;
        this.mediaState = 'stopped';
        // TODO: remove 'paused' once supported in MedaiRecorderState
        this.mediaRecorderState = 'stopped';
        this.recordingStartTime = Date.now();
        this.pauseStartTime = Date.now();
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /@0\?PW/i,
                callback: (match) => {
                    this.socket.send(`\x06@0PW0${this.power ? '0' : '2'}`);
                },
            },
            {
                name: 'elapsedTime',
                regExp: /@0\?ET/i,
                callback: (match) => {
                    const recTime = Date.now() - this.recordingStartTime;
                    const elapsedTimeS = recTime / 1000;
                    const hours = Math.trunc(elapsedTimeS / 3600);
                    const minutes = Math.trunc((elapsedTimeS - hours * 3600) / 60);
                    const seconds = Math.trunc(elapsedTimeS - hours * 3600 - minutes * 60);
                    this.socket.send(`\x06@ET${hours.toString().padStart(3, '0')}${minutes
                        .toString()
                        .padStart(2, '0')}${seconds.toString().padStart(2, '0')}`);
                },
            },
            {
                name: 'oneTrackRecording',
                regExp: /@0\?OR/i,
                callback: (match) => {
                    this.socket.send(`\x06@0OR01`); // one touch recording off
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /@0\?VN/i,
                callback: (match) => {
                    this.socket.send(`\x06@0VN12345`);
                },
            },
            {
                name: 'oneTouchRecordingQuery',
                regExp: /@0\?OT/i,
                callback: (match) => {
                    this.socket.send(`\x06@0OR01`); // OR disabled
                },
            },
            {
                name: 'powerSet',
                regExp: /@023(PW|12)/i,
                callback: (match) => {
                    this.power = match[1] === 'PW';
                    this.socket.send(`\x06`);
                },
            },
            {
                name: 'trackNumberQuery',
                regExp: /@0\?Tr/i,
                callback: (match) => {
                    this.socket.send(`\x06@0Tr${this.currentTrack.toString().padStart(4, '0')}`);
                },
            },
            {
                name: 'totalTracksQuery',
                regExp: /@0\?Tt/i,
                callback: (match) => {
                    this.socket.send(`\x06@0Tt${this.totalTracks.toString().padStart(4, '0')}`);
                },
            },
            {
                name: 'trackNameGetFromIndex',
                regExp: /@0\?Tn(\d+)/i,
                callback: (match) => {
                    this.socket.send(`\x06@0Tn/010120230050${this.currentTrack
                        .toString()
                        .padStart(4, '0')}_DN_900R.mp3`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /@0\?VN(\d+)/i,
                callback: (match) => {
                    this.socket.send(`\x06@0VN00010C00DN-700R`);
                },
            },
            {
                name: 'playRecordStopPause',
                regExp: /@023(.+)/i,
                callback: (match) => {
                    let response = '';
                    if (match[1] === '32') {
                        // next
                        this.mediaState = 'playing';
                        this.currentTrack++;
                        if (this.currentTrack > this.totalTracks)
                            this.currentTrack = 1;
                        response = `\x06@0Tr${this.currentTrack.toString().padStart(4, '0')}\r@0STPL`;
                    }
                    else if (match[1] === '33') {
                        //previous
                        this.mediaState = 'playing';
                        this.currentTrack--;
                        if (this.currentTrack < 1)
                            this.currentTrack = this.totalTracks;
                        response = `\x06@0Tr${this.currentTrack.toString().padStart(4, '0')}\r@0STPL`;
                    }
                    else if (match[1] === '50') {
                        this.mediaState = 'reversing';
                        response = '\x06@0STRW';
                    }
                    else if (match[1] === '52') {
                        this.mediaState = 'forwarding';
                        response = '\x06@0STFF';
                    }
                    else if (match[1] === '53') {
                        // play
                        this.mediaState = 'playing';
                        response = '\x06@0STPL';
                    }
                    else if (match[1] === '54') {
                        // stop
                        this.mediaState = 'stopped';
                        this.mediaRecorderState = 'stopped';
                        this.recordingStartTime = Date.now();
                        response = '\x06@0STST';
                    }
                    else if (match[1] === '55') {
                        // recording
                        this.mediaState = 'stopped';
                        if (this.mediaRecorderState !== 'paused') {
                            this.recordingStartTime = Date.now();
                        }
                        else {
                            // Delay the recording start time by the amount of time we've been paused
                            const pausedTime = Date.now() - this.pauseStartTime;
                            this.recordingStartTime += pausedTime;
                        }
                        this.mediaRecorderState = 'recording';
                        response = '\x06@0STRE';
                    }
                    else if (match[1] === 'Rp') {
                        this.mediaRecorderState = 'paused';
                        this.pauseStartTime = Date.now();
                        response = '\x06@0STRp';
                    }
                    this.socket.send(response);
                },
            },
            {
                name: 'status',
                regExp: /@0\?ST/i,
                callback: (match) => {
                    let response = '';
                    if (this.mediaRecorderState === 'stopped') {
                        response = '\x06@0STST';
                    }
                    else if (this.mediaRecorderState === 'paused') {
                        response = '\x06@0STRP';
                    }
                    else if (this.mediaRecorderState === 'recording') {
                        response = '\x06@0STRE';
                    }
                    else if (this.mediaState === 'paused') {
                        response = '\x06@0STPP';
                    }
                    else if (this.mediaState === 'playing') {
                        response = '\x06@0STPL';
                    }
                    else if (this.mediaState === 'forwarding') {
                        response = '\x06@0STFF';
                    }
                    else if (this.mediaState === 'reversing') {
                        response = '\x06@0STRW';
                    }
                    else if (this.mediaState === 'stopped') {
                        // stopped
                        response = '\x06';
                    }
                    else {
                        response = '\x06';
                    }
                    this.socket.send(response);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`\x15`);
                },
            },
        ];
    }
}
Denon900R.emulatorType = 'socketEmulator';
Denon900R.key = '-Ng0-GSYbUtU_bxdP2kO';
